<div class="row table-header fw-bold py-2 mt-2">
    <div
        [ngClass]="showBootStockActionColumn() ? 'col-3' : 'col-4'"
        class="offset-1"
        (click)="sortFieldBy('materialIdentifier.materialNumber.value')"
    >
        <span [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_MATNO'"> </span>
        @if (orderField().newValue === 'materialIdentifier.materialNumber.value') {
            <span class="sort-order" [ngClass]="{ reverse: isReverse() }"></span>
        }
    </div>
    <div class="col-4" [ngClass]="showBootStockActionColumn() ? 'ps-4' : ''" (click)="sortFieldBy('description.value')">
        <span [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_MATERIAL_DESC'"></span>
        @if (orderField().newValue === 'description.value') {
            <span class="sort-order" [ngClass]="{ reverse: isReverse() }"></span>
        }
    </div>
    <div [ngClass]="showBootStockActionColumn() ? 'ps-0 col-2' : 'col-3'" (click)="sortFieldBy('deliveredQuantity')">
        <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_QUANTITY" class="d-none d-lg-inline"></span>
        <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_QTY" class="d-inline d-lg-none"></span>
        @if (orderField().newValue === 'deliveredQuantity') {
            <span class="sort-order" [ngClass]="{ reverse: isReverse() }"></span>
        }
    </div>
    @if (showBootStockActionColumn()) {
        <div class="col-2 ps-0" (click)="sortFieldBy('bootStockAction')">
            <span translate="CONFIRMATION_MATERIAL_CSE_STOCK_LABEL_ACTION"></span>
            @if (orderField().newValue === 'bootStockAction') {
                <span class="sort-order" [ngClass]="{ reverse: isReverse() }"></span>
            }
        </div>
    }
</div>
@if (displayMaterials().length > 0) {
    @for (material of displayMaterials(); track material) {
        <div class="row table-row">
            <pace-confirmation-material-stock-details-expandable
                [material]="material"
                [bootStock]="bootStock()"
                [isBootStock]="isBootStock()"
                [showBootStockActions]="showBootStockActions()"
                [isLoadingBootStockActions]="isLoadingBootStockReturnIds()"
                [isModelNotification]="isModelNotification()"
                [bootstockReturnIds]="bootStockReturnIds()"
                [smartlockers]="smartLockers()"
                (bootstockReturnSuccess)="bootStockReturnSuccess.emit()"
                (smartlockerPickup)="smartLockerPickup.emit()"
                (switchToBootStock)="switchToBootStock.emit()"
            ></pace-confirmation-material-stock-details-expandable>
        </div>
    }
} @else {
    <p class="text-center mt-2" [translate]="'CONFIRMATION_MATERIAL_CSE_STOCK_NO_MATERIALS_FOUND'"></p>
}
